import React from 'react';
import { Form, FormItemProps as ANTDFormItemProps } from 'antd';
import * as eaw from 'eastasianwidth';
import { useTranslation } from 'react-i18next';

type FormItemProps = ANTDFormItemProps & {
  labelMessage?: string | null;
  isCheckFullWidth?: boolean;
  isNumber?: boolean;
};

const FormItem = (props: FormItemProps): React.ReactElement => {
  const { t } = useTranslation();

  const messageContent = props?.isNumber
    ? 'common.half-width-number-validation'
    : 'common.half-width-character-validation';

  const rules = props?.rules || [];

  if (props?.isCheckFullWidth) {
    rules.push({
      message: t(messageContent, {
        label: props?.labelMessage || props?.label || '',
      })!,
      validator(_, value): Promise<any> {
        if (typeof value === 'string' || typeof value === 'number') {
          const validateValue = value.toString();
          if (eaw.length(validateValue) === validateValue.length) {
            return Promise.resolve();
          }
          return Promise.reject();
        }
        return Promise.resolve();
      },
    });
  }

  if (props?.isNumber) {
    rules.push({
      message: t(messageContent, {
        label: props?.labelMessage || props?.label || '',
      })!,
      validator(_, value: string): Promise<any> {
        if (value && !Number(value)) {
          return Promise.reject();
        }
        return Promise.resolve();
      },
    });
  }

  return <Form.Item {...props} rules={rules} validateFirst />;
};

export default FormItem;
